// extracted by mini-css-extract-plugin
export default {"soundFull":"PageBase_soundFull__oDYfB","soundMute":"PageBase_soundMute__P3w4S"};